<template>
    <div class="row">
        <div class="col-12">
            <label :for="`input${name}`">{{title}}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i :class="icon + ' fa-fw'"></i>
                    </span>
                </div>
                <select
                    class="custom-select"
                    :id="`${id}_input`"
                    :name="name ? name + '[]' : false"
                    multiple
                    :style="height"
                    ref="select"
                    :required="required"
                    :readonly="readonly"
                    :disabled="disabled"
                    :value="value"
                    v-model="actualVal"
                    v-on:change="$emit('change', actualVal);"
                >
                    <option :key="x.id" v-for="x in listData" v-bind:value="x.id">{{x.name}}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        name: String,
        id: String,
        "data-type": String,
        icon: String,
        required: {
            type: Boolean,
            default: true
        },
        readonly: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: true
        },
        height: {
            type: String,
            default: "height: 184px"
        },
        value: {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        return {
            listData: [],
            actualVal: this.value,
            url: window.location.pathname
        };
    },
    mounted() {
        this.popData();
    },
    methods: {
        popData: function() {
            var self = this;
            switch (this.dataType) {
                case "usersList":
                    axios
                        .get(self.url + "/userList")
                        .then(function(response) {
                            self.listData = response.data;
                        })
                        .catch(function(error) {
                            console.error(error);
                        });
                    break;
                case "listQueue":
                    axios
                        .get(self.url + "/listQueue")
                        .then(function(response) {
                            self.listData = [...response.data];
                        })
                        .catch(function(error) {
                            console.error(error);
                        });
                    break;
                case "listDepartment":
                    axios
                        .get(self.url + "/listDepartment")
                        .then(function(response) {
                            self.listData = [...response.data];
                        })
                        .catch(function(error) {
                            console.error(error);
                        });
                    break;
            }
        }
    }
};
</script>
